// extracted by mini-css-extract-plugin
export default {"container":"PopupContainer_container__pQTE4","content":"PopupContainer_content__-uN2Q"};